import pathPrefix from '@/pathPrefix.js';

let routes = [
    {
      path: {
        ro: `${pathPrefix}/home`,
        en: "/en"
      },
      name: "Acasă",
      hasChildren: false
    },
    {
      path: {
        ro: `${pathPrefix}/about`,
        en: ""
      },
      name: "Despre",
      hasChildren: false
    },
    {
      path: {
        ro: `${pathPrefix}/trainings`,
        en: ""
      },
      name: "Traininguri",
      hasChildren: false
    },
    {
      path: {
        ro: `${pathPrefix}/contact`,
        en: ""
      },
      name: "Contact",
      hasChildren: false
    },
    {
      path: {
        ro: `${pathPrefix}/register`,
        en: ""
      },
      name: "Înregistrare",
      hasChildren: false
    },
  ]

  export default routes;